import Admin from "us.collection.admin/sagas";
import { PaymentAgreementSagas } from "./PaymentAgreement";
import { ActivitySagas } from "./ActivityExecution";
import { HandlerSagas } from "./Handler";
import { GDPRCommentSagas } from "./GDPRComment";

export default [
  ...Admin,
  ...PaymentAgreementSagas,
  ...ActivitySagas,
  ...HandlerSagas,
  ...GDPRCommentSagas,
];
